export default __webpack_public_path__ + "static/media/audio-details.83b6aaa7.png";